import React from 'react';
import { FileTextIcon, UploadIcon, XIcon } from 'lucide-react';
import { Field } from './Field';
import { formatFileSize } from '../../utils/validation';
type FileFieldProps = {
  id: string;
  label: string;
  file: File | null;
  onChange: (file: File | null) => void;
  error?: string;
  hint?: string;
};
export function FileField({
  id,
  label,
  file,
  onChange,
  error,
  hint
}: FileFieldProps) {
  return <Field id={id} label={label} hint={hint} error={error} data-id="element-52" data-mp="1rzwbzmbp2jkl">
      {file ? <div className={`flex items-center justify-between gap-4 border bg-paper px-4 py-3 ${error ? 'border-danger' : 'border-line'}`} data-id="element-53" data-mp="1x0k0a08jgmb4">
          <span className="flex min-w-0 items-center gap-3" data-id="element-54" data-mp="1nzcfmkyy3jzi">
            <FileTextIcon className="h-5 w-5 shrink-0 text-gold-deep" aria-hidden="true" data-id="element-55" data-mp="1nzvvzx8y60bf" />
            <span className="truncate text-sm text-ink" data-id="element-56" data-mp="3dflj21un62qn">{file.name}</span>
            <span className="shrink-0 text-xs text-muted" data-id="element-57" data-mp="3idn42sbmoc4r">{formatFileSize(file.size)}</span>
          </span>
          <button id={id} type="button" onClick={() => onChange(null)} aria-describedby={error ? `${id}-error` : undefined} className="flex shrink-0 items-center gap-1 rounded-sm px-2 py-1 text-sm font-medium text-navy transition-colors duration-150 ease-out hover:bg-navy/5" data-id="element-58" data-mp="bsuljt8jxcbd">
            <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-59" data-mp="gmytoftjzqe1" />
            Remove<span className="sr-only" data-id="element-60" data-mp="3p17idcsyfx0x"> {file.name}</span>
          </button>
        </div> : <div className="flex items-center gap-4 border border-dashed border-navy/25 bg-white px-4 py-4 focus-within:border-navy focus-within:ring-2 focus-within:ring-navy/10" data-id="element-61" data-mp="3l0f4u7d1v5yu">
          <UploadIcon className="h-5 w-5 shrink-0 text-gold-deep" aria-hidden="true" data-id="element-62" data-mp="3tz96ic58mmj9" />
          <span className="text-sm text-muted" data-id="element-63" data-mp="1e7v3gfee3lbf">PDF, DOC or DOCX · up to 5 MB</span>
          <input id={id} name={id} type="file" accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" onChange={e => onChange(e.target.files?.[0] ?? null)} aria-describedby={hint ? `${id}-hint` : undefined} className="ml-auto w-[9.5rem] text-sm text-navy file:mr-0 file:cursor-pointer file:rounded-sm file:border file:border-navy/25 file:bg-white file:px-3 file:py-1.5 file:text-sm file:font-medium file:text-navy hover:file:border-navy" data-id="element-64" data-mp="199jvybbkhmwd" />
        </div>}
    </Field>;
}